import { useTasksKanbanLogsApi } from '@api/tasks-kanban/logs.hook'
import { parseLogFilterParams } from '@hooks/tasks-kanban/filters/parse-log-filter-params'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const id = to.params.id

  if (typeof id !== 'string' || !id) return

  const params = parseLogFilterParams(to.query)

  void useTasksKanbanLogsApi({ id, params })
})